module.exports = __webpack_public_path__ + "static/media/saude.605ef9ca.svg";